import { MDSShortcutKeyCharacter, MDSShortcutKeyProps } from "./shortcut-key.types";
import { StyledShortcutKeyWrapper, StyledShortcutKeyText } from "./shortcut-key.style";
import { MDSShortcutKeyCharacterMapping } from "@/mds/components/shortcut-key/shortcut-key.mapping";
import styled from "@emotion/styled";

export const MDSShortcutKey = ({ character, inline = false }: MDSShortcutKeyProps) => {
  const isFixedWidth = ![
    MDSShortcutKeyCharacter.Space,
    MDSShortcutKeyCharacter.Tab,
    MDSShortcutKeyCharacter.Escape,
  ].includes(character);

  return (
    <StyledShortcutKeyWrapper $inline={inline} $isFixedWidth={isFixedWidth}>
      <StyledShortcutKeyText>{MDSShortcutKeyCharacterMapping[character]}</StyledShortcutKeyText>
    </StyledShortcutKeyWrapper>
  );
};

export const MDSShortcutKeyGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[1]};
`;
